package org.hs_soft.runmynesto.pages.home.sub_page.customer_card.components.tabs.customer_card_tab.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.width
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.customer_card.loyalty_card_detail.LoyaltyCardDetail
import org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card.DiscountNoEnum
import org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card.TelephoneCodeEnum
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.jetbrains.compose.web.css.minus
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text

@Composable
fun Owner(
    selectedLoyaltyCard: LoyaltyCardDetail?,
    updateLoyaltyCardInfo: (String, dynamic) -> Unit,
    windowSizeMode: WindowSizeModeEnum,
)
{
    val isUser=selectedLoyaltyCard?.isUser?:false

    Column()
    {
        MediumContentTitle(
            title = Strings.current().owner,
        )

        if (windowSizeMode== WindowSizeModeEnum.Desktop){
            Row()
            {
                Content(
                    isUser=isUser,
                    selectedLoyaltyCard=selectedLoyaltyCard,
                    updateLoyaltyCardInfo={title:String,value:dynamic->
                        updateLoyaltyCardInfo(title,value)
                    }
                )

            }
        }else{
            Column()
            {
                Content(
                    isUser=isUser,
                    selectedLoyaltyCard=selectedLoyaltyCard,
                    updateLoyaltyCardInfo={title:String,value:dynamic->
                        updateLoyaltyCardInfo(title,value)
                    }
                )

            }
        }



    }



}

@Composable
private fun Content(
    selectedLoyaltyCard: LoyaltyCardDetail?,
    isUser: Boolean,
    updateLoyaltyCardInfo: (String, dynamic) -> Unit
) {
    OwnerLeftContent(
        selectedLoyaltyCard = selectedLoyaltyCard,
        isUser = isUser,
        updateLoyaltyCardInfo = { title: String, value: dynamic ->
            updateLoyaltyCardInfo(title, value)
        }
    )

    Box(
        modifier = Modifier
          .width(Dimen.largePadding)
    )

    OwnerRightContent(
        selectedLoyaltyCard = selectedLoyaltyCard,
        isUser = isUser,
        updateLoyaltyCardInfo = { title: String, value: dynamic ->
            updateLoyaltyCardInfo(title, value)
        }
    )
}

@Composable
private fun OwnerLeftContent(
    selectedLoyaltyCard: LoyaltyCardDetail?,
    isUser: Boolean,
    updateLoyaltyCardInfo:(String, dynamic)->Unit,
) {
    Column()
    {
        CustomEditText(
            modifier = Modifier ,
            label = Strings.current().cardName,
            value = selectedLoyaltyCard?.name?:"",
            marginBottom = Dimen.highLargePadding,
            isRequired = false,
            isEnabled = !isUser,
            hint = "",
            onFocusIn = {  },
            onFocusOut = {
                 updateLoyaltyCardInfo(
                     ApiUtils.Field.name,
                     it
                 )
            },
            onInputChange = {it, validation ->

            },
        )

        CustomEditText(
            modifier = Modifier ,
            label = Strings.current().salutation,
            isEnabled = !isUser,
            value =selectedLoyaltyCard?.salutation?:"",
            marginBottom = Dimen.highLargePadding,
            isRequired = false,
            hint = "",
            onFocusIn = { },
            onFocusOut = {
                updateLoyaltyCardInfo(
                    ApiUtils.Field.salutation,
                    it
                )
            },
            onInputChange = {it, validation ->

            },
        )

        CustomEditText(
            modifier = Modifier ,
            label = Strings.current().clientName,
            isEnabled = !isUser,
            value = selectedLoyaltyCard?.clientName?:"",
            marginBottom = Dimen.highLargePadding,
            isRequired = false,
            hint = "",
            onFocusIn = {   },
            onFocusOut = {
                updateLoyaltyCardInfo(
                    ApiUtils.Field.clientName,
                    it
                )
            },
            onInputChange = {it, validation ->

            },
        )

        CustomEditText(
            modifier = Modifier ,
            isEnabled = !isUser,
            label = Strings.current().firstName,
            value = selectedLoyaltyCard?.clientSurname?:"",
            marginBottom = Dimen.highLargePadding,
            isRequired = false,
            hint = "",
            onFocusIn = { },
            onFocusOut = {
                updateLoyaltyCardInfo(
                    ApiUtils.Field.clientSurname,
                    it
                )
            },
            onInputChange = {it, validation ->

            },
        )

        CustomEditText(
            modifier = Modifier ,
            isEnabled = !isUser,
            label = Strings.current().addition,
            value = selectedLoyaltyCard?.additive?:"",
            marginBottom = Dimen.highLargePadding,
            isRequired = false,
            hint = "",
            onFocusIn = {},
            onFocusOut = {
                updateLoyaltyCardInfo(
                    ApiUtils.Field.additive,
                    it
                )
            },
            onInputChange = {it, validation ->

            },
        )



    }
}

@Composable
private fun OwnerRightContent(
    selectedLoyaltyCard: LoyaltyCardDetail?,
    isUser: Boolean,
    updateLoyaltyCardInfo:(String, dynamic)->Unit,
) {
    val selectedCountryCode = remember { mutableStateOf<TelephoneCodeEnum?>(null) }

    LaunchedEffect(selectedLoyaltyCard?.validPhoneNumber) {
        selectedCountryCode.value = selectedLoyaltyCard?.validPhoneNumber?.let { phoneNumber ->
            val firstThreeDigits = phoneNumber.take(3)
            TelephoneCodeEnum.entries.find { firstThreeDigits.startsWith(it.code) }
        } ?: TelephoneCodeEnum.OTHER
    }

    Column(
        modifier = Modifier
    )
    {
        CustomEditText(
            modifier = Modifier ,
            label = Strings.current().street,
            isEnabled = !isUser,
            value = selectedLoyaltyCard?.street?:"",
            marginBottom = Dimen.highLargePadding,
            isRequired = false,
            hint = "",
            onFocusIn = {},
            onFocusOut = {
                updateLoyaltyCardInfo(
                    ApiUtils.Field.street,
                    it
                )
            },
            onInputChange = {it, validation ->

            },
        )

        Row(
            modifier = Modifier
                .margin(bottom = Dimen.highLargePadding)
                .width(Dimen.semiLargeEditTextWidth),
            verticalAlignment = Alignment.CenterVertically
        ) {
            CustomEditText(
                modifier = Modifier ,
                isEnabled = !isUser,
                marginRight = Dimen.largePadding,
                label = Strings.current().zipCity,
                width = Dimen.smallEditTextWidth,
                value =selectedLoyaltyCard?.postcode?:"",
                marginBottom = 0.px,
                isRequired = false,
                hint = "",
                onFocusIn = {},
                onFocusOut = {
                    updateLoyaltyCardInfo(
                        ApiUtils.Field.postcode,
                        it
                    )
                },
                onInputChange = {it, validation ->

                },
            )

            CustomEditText(
                modifier = Modifier ,
                label ="",
                isEnabled = !isUser,
                value = selectedLoyaltyCard?.city?:"",
                hasLabelSpace = false,
                width = Dimen.extraSemiMediumEditText.minus(
                    Dimen.largePadding
                ),
                marginBottom = 0.px,
                isRequired = false,
                hint = "",
                onFocusIn = {},
                onFocusOut = {
                    updateLoyaltyCardInfo(
                        ApiUtils.Field.city,
                        it
                    )
                },
                onInputChange = {it, validation ->

                },
            )
        }





        Row(
            modifier = Modifier
                .margin(bottom = Dimen.highLargePadding),
            verticalAlignment = Alignment.CenterVertically
        ) {
            DropDownItem(
                modifier = Modifier.margin(
                    right = Dimen.largePadding
                ),
                disable =isUser,
                itemWidth = Dimen.smallEditTextWidth,
                options = TelephoneCodeEnum.entries,
                label = Strings.current().tel,
                selectedItem =
                    TelephoneCodeEnum.entries.find {
                        it.code==selectedCountryCode.value?.code
                    }

                ,
                displayText = {
                    if (it is TelephoneCodeEnum)
                      it.code?:"" else ""
                },
                onOptionClick = {
//                    val option: TelephoneCodeEnum? = TelephoneCodeEnum.entries.find { item ->
//                        item.toString() == it
//                    }
//                    console.log(option?.code)
//                    if (option != null) {
//                        selectedCountryCode.value=option
//                    }
                    TODO("Must be fixed.")

                }
            )
            CustomEditText(
                modifier = Modifier ,
                label ="",
                isEnabled = !isUser,
                marginBottom = 0.px,
                width = Dimen.extraSemiMediumEditText
                    .minus(Dimen.largePadding),
                value = selectedLoyaltyCard?.validPhoneNumber?.removePrefix(
                    selectedCountryCode.value?.code?:""
                )?:"",
                isDecimal = true,
                isRequired = false,
                hint = "",
                onFocusIn = {

                },
                onFocusOut = {},
                onInputChange = {it, validation ->

                },
            )
        }


        CustomEditText(
            modifier = Modifier ,
            label = Strings.current().email,
            isEnabled = !isUser,
            marginBottom =Dimen.highLargePadding,
            value = selectedLoyaltyCard?.email?:"",
            isRequired = false,
            hint = "",
            onFocusIn = {},
            onFocusOut = {
                updateLoyaltyCardInfo(
                    ApiUtils.Field.email,
                    it
                )
            },
            onInputChange = {it, validation ->

            },
        )

        Box(
            modifier = Modifier
                .height(Dimen.outlinedEditTextParentHeight)
        )
        {
            CheckboxComponent(
                modifier = Modifier
                    .margin(top = Dimen.normalPadding)
                    .align(Alignment.CenterStart) ,
                checkStatus = selectedLoyaltyCard?.isUser?:false,
                title = Strings.current().activate,
                onChecked = {
                    updateLoyaltyCardInfo(
                        ApiUtils.Field.isUser,
                        true
                    )
                },
                onUnChecked = {
                    updateLoyaltyCardInfo(
                        ApiUtils.Field.isUser,
                        false
                    )
                },
            )
        }


    }
}